import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { filter } from 'rxjs';
import { UserFacade } from '@lyceo/homi/user/data-access';
import { toObservable } from '@angular/core/rxjs-interop';

export function personIdLoadedGuard(): CanActivateFn {
  return () => {
    const userFacade: UserFacade = inject(UserFacade);

    return toObservable(userFacade.personIdLoaded).pipe(
      filter((loaded) => loaded),
    );
  };
}
